// Header Scroll Behavior
var bdDidScroll;
var bdLastScrollTop = 0;
var bdDelta = 5;
var bdNavbar = document.querySelector('.header__outer-wrapper');
var bdNavbarHeight = bdNavbar.offsetHeight;

window.addEventListener('scroll', function(event){
    bdDidScroll = true;
});

setInterval(function() {
    if (bdDidScroll) {
        hasScrolled();
        bdDidScroll = false;
    } else {
        // No scrolling has occurred
        bdNavbar.classList.add('no-scrolling');
    }
}, 250);

function hasScrolled() {
    var bdScrollTop = window.pageYOffset || document.documentElement.scrollTop;

    // Remove no-scrolling class if scrolling is detected
    bdNavbar.classList.remove('no-scrolling');

    // Transparent header at the top of the page
    if (bdScrollTop <= 0) {
        bdNavbar.classList.add('transparent');
        bdNavbar.classList.add('moved-completely-up'); // Add class when at the top
        bdNavbar.classList.remove('move-on-up');
        bdNavbar.classList.remove('moving-on-down');
    } else {
        bdNavbar.classList.remove('transparent');
        bdNavbar.classList.remove('moved-completely-up'); // Remove class when not at the top
    }

    if (Math.abs(bdLastScrollTop - bdScrollTop) <= bdDelta) {
        return;
    }

    if (bdScrollTop < bdLastScrollTop) {
        // Header is sliding up
        bdNavbar.classList.add('move-on-up');
        bdNavbar.classList.remove('moving-on-down');
    } else {
        // Header is sliding down
        bdNavbar.classList.add('moving-on-down');
        bdNavbar.classList.remove('move-on-up');
    }

    bdLastScrollTop = bdScrollTop;
}
